/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import {
  DiscountCode,
  IBankAccount,
  ICard,
  InvoiceItem,
  InvoiceFlag,
  InvoicePayment,
  InvoicePaymentInfo,
} from '@core/models';

import { Client } from '@truckstop-tms/zuum-lib';

export interface Invoice {
  id: number;
  clientId: number;
  client: Partial<Client>;
  number?: string;
  dueDate?: Date;
  createdDate?: Date | string;
  type?: INVOICE_TYPES;
  status: INVOICE_STATUSES;
  billingPeriod?: string;
  billingCycle: string;
  paymentTerm?: string;
  sendScheduled: boolean;
  paymentMethodId?: string;
  invoiceItems?: Partial<InvoiceItem>[];
  payments?: Partial<InvoicePayment>[];
  sentAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
  totalAmount: number;
  paidAmount: number;
  discountAmount: number;
  taxAmount: number;
  url: string;
  isFirst: boolean;
  discountCodeId: number;
  discountCode: DiscountCode;
  invoiceFlag: InvoiceFlag | null;
  invoicePaymentInfo: InvoicePaymentInfo;

  // front-end
  paymentMethod: IBankAccount & ICard;
  isSaasInvoice: boolean;
  isOpenSaasInvoice: boolean;
}

export enum INVOICE_TYPES {
  CUSTOM = 'Custom',
  SAAS = 'SAAS',
  PAAS = 'PAAS',
}

export enum INVOICE_STATUSES {
  ToBeBilled = 'To Be Billed',
  Billed = 'Billed',
  PastDue = 'Past Due',
  PartiallyPaid = 'Partially Paid',
  Paid = 'Paid',
  QbError = 'QB Error',
}

export enum INVOICE_PAYMENT_TERMS {
  IMMEDIATELY = 'Due immediately',
  NET_5 = '5 days',
  NET_10 = '10 days',
  NET_15 = '15 days',
  NET_20 = '20 days',
  NET_25 = '25 days',
  NET_30 = '30 days',
}
